import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DeliveryTruckIcon from '@ingka/ssr-icon/paths/delivery-truck';
import StoreIcon from '@ingka/ssr-icon/paths/store';
import styled from 'styled-components';
import { SkapaModalFooter, SkapaModalHeader, SkapaSSRIcon, SkapaSheet } from '@inter-ikea-guida/skapa';
import IkeaLogo from '../assets/ikea-logo.svg';
import { useGuidaPromptContext } from '../context/promptContext';
import useMenu from '../hooks/useMenu';
import { HomeDeliverySheet } from './HomeDeliverySheet';
import { StoreAvailabilitySheet } from './StoreAvailabilitySheet';
const StyledMenuContainer = styled.div `
  margin: 0 ${props => props.$theme.spacing.space150 / 16}rem;
`;
const StyledMenu = styled.ul `
  padding: 0;
  margin: 0;
  margin-left: 0.5rem;
  margin-right: 0.5rem; /* RTL */
  font-weight: ${props => props.$theme.breakpoint.small.fontStyle.headingXSmall.weight ?? ''};
  font-size: ${props => props.$theme.breakpoint.small.fontStyle.headingXSmall.size / 16}rem;
  line-height: ${props => props.$theme.breakpoint.small.fontStyle.headingXSmall.lineHeight / 16}rem;
  color: ${props => props.$theme.color.neutral.grey900};
`;
const StyledMenuItem = styled.li `
  list-style: none;
`;
const StyledMenuButton = styled.button `
  min-height: 3rem;
  display: flex;
  gap: 1rem;
  align-items: center;
  width: 100%;

  /* To remove browser button styling */
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  color: ${props => props.$theme.color.neutral.grey900};
`;
const StyledLogo = styled.img `
  width: ${90 / 16}rem;
  height: ${36 / 16}rem;
`;
const MenuOption = ({ onClick, icon, label, theme, dataTestId }) => {
    return (_jsx(StyledMenuItem, { children: _jsxs(StyledMenuButton, { className: 'menu-option', onClick: onClick, "$theme": theme, "data-testid": dataTestId, "aria-label": label, children: [_jsx(SkapaSSRIcon, { paths: icon, "aria-hidden": true }), label] }) }));
};
export const GuidaMenu = ({ theme, disableLinks, isOpened, onClose, zipCodeOptions, storeSelectorOptions, kompisTranslations, settings, disableExitPrompt }) => {
    const { zipSelectorVisible, storeSelectorVisible, openZipSelector, closeZipSelector, openStoreSelector, closeStoreSelector } = useMenu();
    const { openPrompt } = useGuidaPromptContext();
    const { zipCode, onZipCodeChange, dexfApiKey } = zipCodeOptions;
    const { storeId, stores, onStoreChange } = storeSelectorOptions;
    const store = stores?.find(s => s.id === storeId) ?? null;
    return (_jsxs(_Fragment, { children: [_jsx(SkapaSheet, { "aria-label": 'Menu', dataTestId: 'guida-menu-sheet', fullSize: true, alignment: 'left', visible: isOpened, handleCloseBtn: () => {
                    onClose();
                }, header: _jsx(SkapaModalHeader, { ariaCloseTxt: 'Close menu', dataTestId: 'guida-menu-modal-header' }), footer: _jsx(SkapaModalFooter, { stacked: true, children: disableLinks ? (_jsx(StyledLogo, { src: IkeaLogo, alt: kompisTranslations.summaryPageHeaderIkeaLogoAltText })) : (_jsx("a", { href: settings.kompis.urls.homePageLink, target: '_blank', rel: 'noopener noreferrer', "data-testid": 'menu-ikea-logo-link', onClick: e => {
                            if (!disableExitPrompt) {
                                e.preventDefault();
                                openPrompt();
                            }
                        }, children: _jsx(StyledLogo, { src: IkeaLogo, alt: kompisTranslations.summaryPageHeaderIkeaLogoAltText }) })) }), children: _jsx(StyledMenuContainer, { "$theme": theme, children: _jsxs(StyledMenu, { "$theme": theme, children: [_jsx(MenuOption, { dataTestId: 'guida-menu-zip-code-button', icon: DeliveryTruckIcon, label: zipCode ? zipCode : kompisTranslations.enterZip, onClick: openZipSelector, theme: theme }), _jsx(MenuOption, { dataTestId: 'guida-menu-store-button', icon: StoreIcon, label: store && store.name ? store.name : kompisTranslations.storeSelectorTitle, onClick: openStoreSelector, theme: theme })] }) }) }), _jsx(HomeDeliverySheet, { visible: zipSelectorVisible, closeZipSelector: closeZipSelector, zipCode: zipCode, onZipCodeChange: onZipCodeChange, settings: settings, kompisTranslations: kompisTranslations, dexfApiKey: dexfApiKey }), _jsx(StoreAvailabilitySheet, { visible: storeSelectorVisible, storeId: storeId, stores: stores, onStoreChange: onStoreChange, closeStoreSelector: closeStoreSelector, kompisTranslations: kompisTranslations })] }));
};
//# sourceMappingURL=GuidaMenu.js.map